<div class="student-list-filters-container">
  <div class="students-list-filters-content">
    <mat-form-field class="filter-item input" subscriptSizing="dynamic">
      <mat-label>First Name</mat-label>
      <input
        data-test-id="FIRST_NAME_FILTER_INPUT"
        matInput
        [(ngModel)]="filters.firstName"
        (keydown.enter)="filtersUpdated.emit(filters)"
      />
    </mat-form-field>
    <mat-form-field class="filter-item input" subscriptSizing="dynamic">
      <mat-label>Last Name</mat-label>
      <input
        data-test-id="LAST_NAME_FILTER_INPUT"
        matInput
        [(ngModel)]="filters.lastName"
        (keydown.enter)="filtersUpdated.emit(filters)"
        />
    </mat-form-field>
    <mat-form-field class="filter-item input" subscriptSizing="dynamic">
      <mat-label>
        {{ currentUser.type === UserTypeEnum.TEACHER ? 'Grade Level' : 'Grade' }}
      </mat-label>
      <input
        data-test-id="GRADE_FILTER_INPUT"
        matInput
        [(ngModel)]="filters.grade"
        (keydown.enter)="filtersUpdated.emit(filters)"
      />
    </mat-form-field>
    <mat-form-field class="filter-item input" subscriptSizing="dynamic">
      <mat-label>
        {{ currentUser.type === UserTypeEnum.TEACHER ? 'ID' : 'ID Number' }}
      </mat-label>
      <input
        data-test-id="STUDENT_EXT_ID_FILTER_INPUT"
        matInput
        [(ngModel)]="filters.studentExtId"
        (keydown.enter)="filtersUpdated.emit(filters)"
      />
    </mat-form-field>

    <button
      type="button"
      mat-flat-button
      class="secondary-button header-action-button standard-button filter-button"
      (click)="filtersUpdated.emit(filters)"
      unique-id>
      {{ currentUser.type === UserTypeEnum.TEACHER ? 'Search' : 'Apply Filters' }}
    </button>

  </div>
  <ng-container *ngIf="selectedStudentIds.length !== 0">
    <div class="button-container">
      <button
        *ngIf="hasPrivilege(PrivilegeEnum.TRACK_BEHAVIOR)"
        type="button"
        mat-flat-button
        class="secondary-button header-action-button standard-button "
        (click)="showTrackModalEvent.emit()"
        unique-id>
        Track Students {{selectedStudentIds.length}}
      </button>
      <button
        *ngIf="hasPrivilege(PrivilegeEnum.TRACK_BEHAVIOR)"
        type="button"
        mat-flat-button
        class="secondary-button header-action-button standard-button margin-left"
        (click)="showFastTrackModalEvent.emit()"
        unique-id>
        Fast Track
      </button>
    </div>
  </ng-container>
</div>
